import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const departments = [{
    name: 'General Reception',
    phone: '+91 44 2815 3052',
    email: 'reception@andhraassociation.com'
  }, {
    name: 'Membership Enquiries',
    phone: '+91 44 2815 3052',
    email: 'membership@andhraassociation.com'
  }, {
    name: 'Dining Reservations',
    phone: '+91 44 2815 3052',
    email: 'dining@andhraassociation.com'
  }, {
    name: 'Banquets & Events',
    phone: '+91 44 2815 3052',
    email: 'events@andhraassociation.com'
  }, {
    name: 'Accommodation',
    phone: '+91 44 2815 3052',
    email: 'rooms@andhraassociation.com'
  }];
  return <div className="w-full bg-club-canvas" data-id="element-651">
      {/* Page Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-652">
        <div className="absolute inset-0 z-0 bg-club-green" data-id="element-653">
          <div className="absolute inset-0 opacity-10" data-id="element-654">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-655">
              <defs data-id="element-656">
                <pattern id="pattern-contact" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-657">
                  <path d="M0 40L40 0H20L0 20M40 40V20L20 40" fill="currentColor" fillOpacity="0.5" data-id="element-658" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#pattern-contact)" data-id="element-659" />
            </svg>
          </div>
        </div>
        <div className="relative z-10 text-center px-4 mt-16" data-id="element-660">
          <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-661">
            Contact & Enquiries
          </motion.h1>
          <motion.p className="text-lg text-club-canvas/80 font-light max-w-2xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-662">
            We look forward to assisting you with your enquiry.
          </motion.p>
        </div>
      </section>

      <section className="py-20 px-4 max-w-7xl mx-auto" data-id="element-663">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-664">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-665">
            <div className="bg-white p-8 md:p-10 border border-club-border rounded-sm shadow-sm" data-id="element-666">
              <h2 className="text-3xl mb-6" data-id="element-667">Send an Enquiry</h2>
              <form className="space-y-6" data-id="element-668">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-669">
                  <div data-id="element-670">
                    <label htmlFor="firstName" className="block text-sm font-medium text-club-ink mb-1" data-id="element-671">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-672" />
                  </div>
                  <div data-id="element-673">
                    <label htmlFor="lastName" className="block text-sm font-medium text-club-ink mb-1" data-id="element-674">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-675" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-676">
                  <div data-id="element-677">
                    <label htmlFor="email" className="block text-sm font-medium text-club-ink mb-1" data-id="element-678">
                      Email Address
                    </label>
                    <input type="email" id="email" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-679" />
                  </div>
                  <div data-id="element-680">
                    <label htmlFor="phone" className="block text-sm font-medium text-club-ink mb-1" data-id="element-681">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-682" />
                  </div>
                </div>

                <div data-id="element-683">
                  <label htmlFor="department" className="block text-sm font-medium text-club-ink mb-1" data-id="element-684">
                    Enquiry Type
                  </label>
                  <select id="department" className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-685">
                    <option data-id="element-686">General Enquiry</option>
                    <option data-id="element-687">Membership</option>
                    <option data-id="element-688">Dining Reservation</option>
                    <option data-id="element-689">Banquet / Event Booking</option>
                    <option data-id="element-690">Room Reservation</option>
                  </select>
                </div>

                <div data-id="element-691">
                  <label htmlFor="message" className="block text-sm font-medium text-club-ink mb-1" data-id="element-692">
                    Message
                  </label>
                  <textarea id="message" rows={5} className="w-full p-3 border border-club-border rounded-sm focus:ring-1 focus:ring-club-gold focus:border-club-gold bg-club-canvasAlt/50" data-id="element-693"></textarea>
                </div>

                <button type="submit" className="btn-primary w-full py-4" data-id="element-694">
                  Submit Enquiry
                </button>
              </form>
            </div>
          </motion.div>

          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-12" data-id="element-695">
            <div data-id="element-696">
              <span className="eyebrow block mb-4" data-id="element-697">Location</span>
              <h3 className="text-2xl mb-4" data-id="element-698">
                Andhra Social & Cultural Association
              </h3>
              <div className="space-y-4 text-club-ink/80" data-id="element-699">
                <p className="flex items-start gap-3" data-id="element-700">
                  <MapPin className="text-club-gold shrink-0 mt-1" size={20} data-id="element-701" />
                  <span data-id="element-702">
                    22, Vijayaraghava Rd, Lakshmi Colony,
                    <br data-id="element-703" />
                    T. Nagar, Chennai, Tamil Nadu 600017
                    <br data-id="element-704" />
                    (Behind Residency Hotel), India
                  </span>
                </p>
                <p className="flex items-start gap-3" data-id="element-705">
                  <Clock className="text-club-gold shrink-0 mt-1" size={20} data-id="element-706" />
                  <span data-id="element-707">Open daily: 8:00 AM – 11:00 PM</span>
                </p>
              </div>
            </div>

            <div data-id="element-708">
              <span className="eyebrow block mb-4" data-id="element-709">Directory</span>
              <div className="space-y-6" data-id="element-710">
                {departments.map((dept, i) => <div key={i} className="border-b border-club-border pb-4 last:border-0" data-id="element-711">
                    <h4 className="font-medium text-lg mb-2" data-id="element-712">{dept.name}</h4>
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 text-sm text-club-ink/70" data-id="element-713">
                      <a href={`tel:${dept.phone}`} className="flex items-center gap-2 hover:text-club-green transition-colors" data-id="element-714">
                        <Phone size={16} className="text-club-gold" data-id="element-715" />{' '}
                        {dept.phone}
                      </a>
                      <a href={`mailto:${dept.email}`} className="flex items-center gap-2 hover:text-club-green transition-colors" data-id="element-716">
                        <Mail size={16} className="text-club-gold" data-id="element-717" />{' '}
                        {dept.email}
                      </a>
                    </div>
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}